<template>
  <a-card :bordered="false">
    <list v-show="showList" ref="listComponent" @onEdit="handleEdit" :cities="cities"></list>
    <edit v-if="!showList" :record="record" @onGoBack="handleGoBack" :cities="cities" :suppliers="suppliers"></edit>
  </a-card>
</template>

<script>

import CityApi from '@/api/basicdata/api-city'
import SupplierApi from '@/api/basicdata/api-supplier'
// 动态切换组件
import List from './BusCompanyList'
import Edit from './BusCompanyEdit'

export default {
  name: 'BusCompanyPage',
  components: {
    List,
    Edit
  },
  data () {
    return {
      record: '',
      // 是否显示List
      showList: true,
      // 城市信息列表
      cities: [],
      suppliers:[]
    }
  },
  mounted () {
    this.initLoad()
  },
  methods: {
    // 加载初始数据
    async initLoad () {
      const res = await CityApi.list()
      const sres=await SupplierApi.list()
      this.cities = res.data
      this.suppliers=sres.data
    },
    handleEdit (record) {
      this.record = record || ''
      this.showList = false
    },
    handleGoBack () {
      this.record = ''
      this.$refs.listComponent.refreshCurrentPage()
      this.showList = true
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.showList = true
    }
  }
}
</script>
